module.exports = __webpack_public_path__ + "static/media/icon_dx.29eec30a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/icon_dx.svg
// module id = 585
// module chunks = 0